import { getRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

export const getUserCount = async () => {
  try {
    const { response, logComplete } = await getRequest('analytics/userCount')
    logComplete()
    return response
  } catch (error) {
    logger.error('getUserCount', error)
    throw error
  }
}

export const getLoginData = async (period, limit = 30) => {
  try {
    console.log('Fetching login data for period:', period)
    const { response, logComplete } = await getRequest(`analytics/loginData?period=${period}&limit=${limit}`)
    console.log('Received login data:', response)
    logComplete()
    return response
  } catch (error) {
    console.error('Error fetching login data:', error)
    logger.error('getLoginData', error)
    throw error
  }
}
